import { formatNumber, guardNumber } from "@msuite/utils/numbers";
import type { Enums } from "@msuite/utils/types";
import { Fragment } from "react";
import { Meter } from "react-aria-components";

/** Props Interface */
export interface ProgressMeterProps {
	value: number;
	hideLabel?: boolean;
}

export function ProgressMeter({ value, hideLabel }: ProgressMeterProps) {
	/** Percentage */
	const percentage = Number(
		formatNumber(Math.min(Math.max(guardNumber(value), 0), 100), "integer", 0),
	);

	/** Render */
	return (
		<Meter
			value={percentage}
			className="w-full flex flex-row gap-2 items-center"
		>
			{({ percentage, valueText }) => (
				<Fragment>
					<div className="flex relative justify-between gap-2 w-full rounded-full bg-primary-100 dark:bg-primary-700 h-1.5">
						<div
							className={"absolute top-0 left-0 h-full w-full rounded-full focus:ring-2"}
							style={{
								width: `${percentage}%`,
								backgroundColor: `var(--color-${getColor(value)}-500)`,
							}}
						/>
					</div>
					{!hideLabel && (
						<div className="min-w-10">
							<p className="text-xs text-right">{valueText}</p>
						</div>
					)}
				</Fragment>
			)}
		</Meter>
	);
}

function getColor(value: number): Enums<"color"> {
	if (value < 50) return "red";
	if (value < 85) return "amber";
	return "emerald";
}
